import React from "react";
import { ChevronDown, ChevronRight, Lock } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type SidebarItemProps = {
  number: number;
  title: string;
  active?: boolean;
  children?: React.ReactNode;
  expanded?: boolean;
  onClick?: () => void;
  hasChildren?: boolean;
  onNavigate?: () => void;
  locked?: boolean;
};

const SidebarItem = ({
  number,
  title,
  active = false,
  children,
  expanded = false,
  onClick,
  hasChildren = false,
  onNavigate,
  locked = false,
}: SidebarItemProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (locked) {
      e.stopPropagation();
      return;
    }
    if (hasChildren && onClick) {
      onClick();
    } else if (onNavigate) {
      e.stopPropagation();
      onNavigate();
    }
  };

  const content = (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-2 rounded-md cursor-pointer transition-colors",
        locked
          ? "opacity-50"
          : active
            ? "bg-blue-50 text-teachstack-purple"
            : "hover:bg-gray-100",
      )}
      onClick={handleClick}
    >
      {hasChildren ? (
        expanded ? (
          <ChevronDown className="h-4 w-4 text-gray-400" />
        ) : (
          <ChevronRight className="h-4 w-4 text-gray-400" />
        )
      ) : null}
      <span className="text-sm flex-1">
        {number}. {title}
      </span>
      {locked && <Lock className="h-4 w-4 text-gray-400" />}
    </div>
  );

  return (
    <div className="w-full">
      {locked ? (
        <Tooltip>
          <TooltipTrigger asChild>{content}</TooltipTrigger>
          <TooltipContent>
            <p>Purchase a subscription to unlock</p>
          </TooltipContent>
        </Tooltip>
      ) : (
        content
      )}
      {expanded && children && !locked && (
        <div className="pl-8 mt-1 border-l border-gray-200 ml-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;
